module.exports = __webpack_public_path__ + "9a54d80f786991dd36e8f6010c8fe22f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/google_2023_chart.png
// module id = 1683
// module chunks = 0